import { render } from "./InputGallery.vue?vue&type=template&id=453de688&scoped=true"
import script from "./InputGallery.vue?vue&type=script&lang=js"
export * from "./InputGallery.vue?vue&type=script&lang=js"

import "./InputGallery.vue?vue&type=style&index=0&id=453de688&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453de688"]])

export default __exports__